










































































































import {Vue, Component} from 'vue-property-decorator';
import mainToolbar from '../toolbar/toolbar.vue';
import resume from './resume';
import aboutPortrait from './portrait/portrait.vue';
import resumeSectionItem from './resume-section-item.vue';

@Component({
  components: {
    mainToolbar,
    aboutPortrait,
    resumeSectionItem,
  },
})
export default class About extends Vue {
  private filterBy = 'all';

  private mounted() {
    this.$message({
      message: 'Website under construction. More content will be added soon :)',
      type: 'warning',
      duration: 5000,
    });
  }

  private get resume() {
    return resume;
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/about/about.vue